module.exports = __webpack_public_path__ + "img/diagrams.ff26ecab.jpg";